
import { FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { SiGooglescholar } from 'react-icons/si';
import NewDynamicBackground from '../components/NewDynamicBackground'; // import background

import './Home.css';


function Home() {
  return (
    <div>
     
      <div className="home-container">
      {/* Dynamic background <NewDynamicBackground variant={1}/>*/}
     <NewDynamicBackground variant={1}/>  
      {/* Left Column */}
      <div className="home-left">
        <img
          src={`${process.env.PUBLIC_URL}/assets/BinYu_Profile_image.jpg`}
          alt="Profile"
        />
        <h2 className="home-name">Bin Yu</h2>
        <p className="home-title">Associate Professor in HCI</p>
        <p className="home-affiliation">Digital Life Group, FDMCI, AUAS</p>

        {/* Social Icons */}
        <div className="social-icons">
          <a
            href="https://www.linkedin.com/in/bin-yu-85935450/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#315bea'}}
          >
            <FaLinkedin />
          </a>
          <a
            href="https://scholar.google.nl/citations?user=uhdNK1EAAAAJ&hl=en"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#315bea' }}
          >
           <SiGooglescholar/>
          </a>
          <a href="mailto:b.yu@hva.nl" style={{ color: '#315bea'}}>
            <FaEnvelope />
          </a>
        </div>
      </div>

      {/* Right Column */}
      <div className="home-right">
        <section className="introduction">
        <h2 >Hello!</h2>
        <p className="home-text">
         Welcome to my website! I am Associate Professor at the <a href="https://www.digitallifecentre.nl/" target="_blank" rel="noopener noreferrer">Digital Life Research Group </a> in the
         Faculty of Digital Media & Creative Industries (<a href="https://www.amsterdamuas.com/about-auas/organisation/faculties/digital-media-and-creative-industries" target="_blank" rel="noopener noreferrer">FDMCI</a>), 
         Amsterdam University of Applied Sciences (<a href="https://www.amsterdamuas.com/" target="_blank" rel="noopener noreferrer">AUAS</a>).
         My research focuses on designing human-centered technologies that enhance both health experiences and outcomes. 
         I explore how people engage with health technologies across domains, from wellbeing and rehabilitation to clinical decision-making, 
         with a particular emphasis on systems that prioritize human experience, support human–technology collaboration, and integrate seamlessly into daily life.
        </p>
        <p className="home-text">
          I received my M.Sc. in Biomedical Engineering from Northeastern University in 2012 and my Ph.D. in Human-Computer Interaction from <a href="https://www.tue.nl/en/our-university/departments/industrial-design" target="_blank" rel="noopener noreferrer">Industrial Design</a>, Eindhoven University of Technology in 2018. 
          Before my current role, I worked as an Assistant Professor in Behavior Data Science at <a href="https://www.nyenrode.nl/en" target="_blank" rel="noopener noreferrer">Nyenrode Business University</a> and worked at <a href="https://www.philips.com/a-w/about/innovation/experience-design.html" target="_blank" rel="noopener noreferrer">Philips</a> as a Data Designer from 2019 to 2022. 
          Since 2024, I have been with the Digital Life Research Group, where I currently focus on four research areas: biofeedback for stress and relaxation, digital rehabilitation for home recovery, human-AI collaboration in clinical settings, and data-enabled participatory health.
        </p>
        </section>

        <section className="news">
          <h2 >News</h2>
            <ul className="news-list">
              <li className="news-item">
                <span className="news-date">Sep 2026</span>
                <p>REHABOT project granted by (<a href=" https://www.sia-projecten.nl/project/rehabot-developing-an-ai-assistant-to-support-geriatric-rehabilitation-at-home" target="_blank" rel="noopener noreferrer">RAAK-publiek</a>), started Sep 2026.</p>
              </li>

               <li className="news-item">
                <span className="news-date">Jan 2026</span>
                <p>WarmStone presented at C&C 2026 in London</p>
              </li>

             <li className="news-item">
                <span className="news-date">May 2026</span>
                <p>MEDEL project granted by CLICKNL Power of Design </p>
              </li>

               <li className="news-item">
                <span className="news-date">Jan 2026</span>
                <p>ASafePlace and CoBreath (honorable mention) presented at CHI 2026.</p>
              </li>

              <li className="news-item">
                <span className="news-date">Nov 2025</span>
                <p>RehabTwin has been awarded funding by Health-Holland.</p>
              </li>


            </ul>
                  
       

        </section>


      </div>
    </div>
    </div>

  );
}

export default Home;
